/**
 * Copy for the plain-language role snapshot shown in place of the permission
 * matrix (MKT-527).
 *
 * Every line is a sentence a License Manager would recognise, not a restatement
 * of a permission code. Deriving the lines mechanically from the codes produced
 * ten of them per role — including "Region — View · Default" and "Reimbursement
 * — Show · Profile" — which is the matrix again in a thinner disguise. These are
 * hand-written and deliberately few.
 */
export const CAPABILITY_COPY = {
  territoryOwn: 'Work their own territories',
  territoryDirectReports: 'Work their own and their reps’ territories',
  territoryCompany: 'Work any territory in the company',

  savedWork: 'Save filters, searches, and encounter sets',
  savedWorkCompany:
    'Save filters, searches, and encounter sets for the company',
  savedWorkReadOnly: 'See saved filters, searches, and encounter sets',

  scoutAi: 'Use Scout AI',
  territoryOptimization: 'Use Territory Optimization',

  exports: 'Export table data',
  bulkExport: 'Export every provider in a territory',

  users: 'Add, edit, and deactivate users',
  usersReadOnly: 'See the company’s users',
  roles: 'Create and edit roles',

  settings: 'Manage company settings',
  integrations: 'Configure CRM integrations',
} as const;

export const ROLE_SUMMARY_COPY = {
  /**
   * The disclosure. Collapsed by default: someone assigning a known role should
   * see a scannable list of role names, and only open the one they are unsure
   * about.
   */
  showDetails: 'View details',
  hideDetails: 'Hide details',

  /**
   * A role with no permissions we describe. Rare, but a bare empty list would
   * read as a rendering failure rather than as an intentionally narrow role.
   */
  empty: 'This role does not grant any access on its own.',

  /**
   * The honest tail. Anything the catalog does not classify is counted rather
   * than dropped, so a permission area added to the API is visible as *some*
   * access even before someone writes copy for it — see `UNDESCRIBED_RESOURCES`.
   */
  undescribed: (count: number) =>
    `Plus ${count} more ${count === 1 ? 'permission' : 'permissions'}`,
} as const;
